import http from 'common-module/src/util/http';


/**
 * 根据信息  获取聊天机器人回复
 * @param {*} { projectId: number, content: string}
 * @returns
 */
export async function requestRobotReplay(data) {
  return http.post('/rule-robot/talk-to-config', data, {
    showError: false
  });
}

/**
 * 根据信息  获取聊天机器人回复
 * @param {*} { projectId: number, content: string}
 * @returns
 */
export async function requestRobotReplayV2(data) {
  return http.post('/rule-robot/talk-to-config/V2', data, {
    showError: false
  });
}

/**
 * 发送消息
 * @param {*} { text: string}
 * @returns
 */
export async function sendRobotChatText(data) {
  return http.post('/chat/input', data);
}

/**
 * 发送推荐内容
 * @returns
 */
export async function sendRobotChatRecommend(data) {
  return http.post('/chat/action', data);
}

/**
 * 清空上下文
 * @returns
 */
export async function clearRobotChatRecommend(data = {}) {
  return http.post('/chat/clear', data);
}
